import { AxiosPromise } from 'axios'

import { Classification, Tag, Team } from '@driftt/api-types'

import { CustomerAPI } from 'api'
import { Segment } from 'api/targetingAuditLog'
import { mapResponse } from 'utils/api'

import { IOpportunity } from './types'

export const fetchClassifications = () =>
  CustomerAPI.get<Classification[]>(`/classifications`).then(mapResponse)

export const fetchOrgTags = (orgId: number) =>
  CustomerAPI.get<Tag[]>(`/organizations/${orgId}/tags`).then(mapResponse)

export const fetchOrgTeams = () =>
  CustomerAPI.get<Team[]>(`/teams`).then(mapResponse)

export const fetchCutover = (orgId: number, namespace: string) =>
  CustomerAPI.get<Record<string, boolean>>(
    `/cutover/organizations/${orgId}?namespace=${namespace}`
  ).then(mapResponse)

//TODO Fix these but in the meantime they dont blow out our limits/ give more data.
export const getRevenueMetricsDrilldownCreated = (
  start: string,
  end: string
): Promise<{ results: Record<string, IOpportunity[]> }> => {
  return CustomerAPI.get(
    `/salesforce/influence_metrics/opportunities/created`,
    { params: { start, end } }
  ).then(mapResponse)
}

export const getRevenueMetricsDrilldownClosed = (
  start: string,
  end: string
): Promise<{ results: Record<string, IOpportunity[]> }> => {
  return CustomerAPI.get(`/salesforce/influence_metrics/opportunities/closed`, {
    params: { start, end },
  }).then(mapResponse)
}

export const getRevenueMetricsDrilldownConvoLinks = (
  accountIds: string[]
): Promise<{ conversationLinksByAccountId: Record<string, string> }> => {
  return CustomerAPI.post(
    `/salesforce/influence_metrics/conversations`,
    accountIds
  ).then(mapResponse)
}

export const getSegmentList = (): AxiosPromise<Segment[]> =>
  CustomerAPI.get('/user_lists')

export const patchUserProperties = (
  userId: number | unknown,
  patchOperation: object
) => CustomerAPI.patch(`/users/${userId}/properties`, patchOperation)

export const fetchUserProperties = async (
  url: string,
  shouldFetch: boolean
): Promise<object[]> => {
  if (!shouldFetch) return []
  const res = await CustomerAPI.get(url)
  return res.data
}

export const bulkUpdateTeams = (payload) =>
  CustomerAPI.patch('/teams/bulk/updateUserTeams', payload)

export const updateSalesRepName = (body) => {
  const { userId, ...rest } = body
  const operations = Object.entries(rest).map(([key, value]) => ({
    operation: 'set',
    property: key,
    value: value,
  }))
  const payload = { operations: operations }
  return CustomerAPI.patch(`/users/${userId}/patchWithPayload`, payload)
}
